export const multilevelFallback = (stores: any[]) => (lv1: string, lv2?: string, lv3?: string) => {
  if (lv2 && lv3) {
    for (let i = 0; i < stores.length; i++) {
      if (stores[i][lv1] && stores[i][lv1][lv2] && stores[i][lv1][lv2][lv3]) {
        return stores[i][lv1][lv2][lv3]
      }
    }

    return ''
  }

  if (lv2) {
    for (let i = 0; i < stores.length; i++) {
      if (stores[i][lv1] && stores[i][lv1][lv2]) {
        return stores[i][lv1][lv2]
      }
    }

    return ''
  }

  for (let i = 0; i < stores.length; i++) {
    if (stores[i][lv1]) {
      return stores[i][lv1]
    }
  }

  return ''
}
